import { Dumbbell, Sparkles, type LucideIcon } from "lucide-react";
import { VenueType } from "./types";

export const venueTypeIcon: Record<VenueType, LucideIcon> = {
  [VenueType.GYM]: Dumbbell,
  [VenueType.SPA]: Sparkles,
  [VenueType.GYM_AND_SPA]: Dumbbell,
};
